import React from 'react';
import { Bonuses } from './components/Bonuses';
import { Differentiators } from './components/Differentiators';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { LookInside } from './components/LookInside';
import { MetaPixel, PIXEL_ID } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { ProblemSolution } from './components/ProblemSolution';
import { ProductShowcase } from './components/ProductShowcase';
import { PurchasePopup } from './components/PurchasePopup';
import { Testimonials } from './components/Testimonials';
import { Volumes } from './components/Volumes';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-slate-50 text-blue-950 selection:bg-yellow-300 selection:text-blue-950" data-id="element-0" data-mp="28ufpyg1ohml6">
      <MetaPixel data-id="element-1" data-mp="23w4c7u89irxo" />
      <main data-id="element-2" data-mp="23ujha3i1d6za">
        <Hero data-id="element-3" data-mp="23v2sz2h3ez4v" />
        <ProblemSolution data-id="element-4" data-mp="23ti8k5ohswkq" />
        <ProductShowcase data-id="element-5" data-mp="3ik7jmqgv0tve" />
        <Volumes data-id="element-6" data-mp="3iiwg8rrbto4t" />
        <LookInside data-id="element-7" data-mp="3ijfunyhrpue3" />
        <Bonuses data-id="element-8" data-mp="3ii4t85bsoyq5" />
        <Pricing data-id="element-9" data-mp="3mlawd43m29se" />
        <Differentiators data-id="element-10" data-mp="3mkrd9k285fcs" />
        <Testimonials data-id="element-11" data-mp="3mk83iqmq9x9u" />
        <Faq data-id="element-12" data-mp="3mjga9mglsbmq" />
        <FinalClose data-id="element-13" data-mp="3mj6lu3b7icj5" />
      </main>
      <Footer data-id="element-14" data-mp="3rbzomln47asl" />
      <PurchasePopup data-id="element-15" data-mp="3rdkhm6ts6loc" />
      <noscript data-id="element-16" data-mp="3rd19fhtxnbni">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-17" data-mp="3relvej26lm9r" />
      </noscript>
    </div>;
}